import React from 'react';
import { AuthContext } from 'contexts';
import { useAppcues } from 'hooks';

const AppcuesIncludedOrgTypes = ['brokerage', 'mlsStaff'];

const AppcuesLoader: React.FC = () => {
  const { auth } = React.useContext(AuthContext);
  const Appcues = useAppcues();

  const getEnvironment = () => {
    const { href } = window.location;
    const domain = href.split('#')[0];
    if (
      domain.includes('//qa.brokerbay.ca') ||
      domain.includes('//qa.brokerbay.com')
    )
      return 'QA';
    if (domain.includes('//localhost')) return 'DEV';
    if (domain.includes('//auto-qa')) return 'DEV';
    return 'PROD';
  };

  const isAppcuesEnabled = () => {
    if (!auth) return false;
    if (!AppcuesIncludedOrgTypes.includes(auth.org.type) || auth.isAssumedNotBB)
      return false;
    if (getEnvironment() === 'DEV') return false;
    return true;
  };

  React.useEffect(() => {
    if (isAppcuesEnabled()) {
      Appcues.identify(auth.id, {
        ...auth,
        environment: getEnvironment() as 'QA' | 'PROD',
        onboardingPortal: auth.org.onboardingPortal?.name,
        country: auth.org.country,
        orgId: auth.org.id,
      });
    }
  }, [auth]);

  return null;
};

export default AppcuesLoader;
